import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Box, Hidden } from '@material-ui/core';
import { ReactComponent as LogoSVG } from '../assets/Logo.svg';
import { useStyles } from './styles';
import { useAppConfiguration } from '../../../shared/hook/useAppConfiguration';
import CreditWidget from '../../../components/credit-widget';
import GreetingBanner from '../../../components/greeting-banner';
import { getUser } from '../../../../services';

const TopBar = () => {
  const classes = useStyles();
  const { data: user } = useQuery(['user'], getUser);
  const { withCredits, withUnlimitedCredits } = useAppConfiguration();

  return (
    <Hidden smDown={withUnlimitedCredits}>
      <Box className={classes.topBarContainer}>
        <Box
          className={
            withCredits ? classes.topBarContent : classes.topBarContentExternal
          }
        >
          {withCredits ? (
            <>
              {/* @ts-ignore next */}
              <Box component={Link} to="/" className={classes.logoWrapper}>
                <LogoSVG />
              </Box>
              <Hidden smDown>
                <Box className={classes.greetingsContainer}>
                  <GreetingBanner />
                </Box>
              </Hidden>
              {!withUnlimitedCredits && (
                <Box className={classes.widgetContainer}>
                  <CreditWidget userCredit={user?.creditBalance} />
                </Box>
              )}
            </>
          ) : (
            <Box className={classes.logoWrapper}>
              <LogoSVG />
            </Box>
          )}
        </Box>
      </Box>
    </Hidden>
  );
};

export default TopBar;
